<template>
  <div class="systemErrorWrap" :class="`-${$store.state.systemError.type}`">
    <div class="systemError" :class="`-${$store.state.systemError.type}`">
      <p class="lead">
        <strong>{{
          !isCbt
            ? 'システムの問題が発生しました。'
            : '回答送信時にエラーが発生しました。'
        }}</strong>
      </p>
      <template v-if="isCbt">
        <p>
          <span>申し訳ありませんが</span>
          <span>以下からトップページにお戻りいただき、</span>
          <span>再度受験をお願いいたします。</span>
        </p>
        <p class="cbtMargin">
          <a href="/magazines/exam/cbt">cbtトップに戻る</a>
        </p>
      </template>
      <p v-else>
        <span>ブラウザの戻るボタンから</span
        ><span>前のページにお戻りいただき、</span><br class="hiddenSp" />
        <span>しばらく経ってから</span><span>再表示してください。</span>
      </p>

      <button
        type="button"
        class="close"
        v-if="$store.state.systemError.type === 'modal'"
        @click="$store.commit('closeSystemError')"
      >
        <img src="@/assets/images/icon/close-main.svg" alt="" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ModalSystemError',
  props: {
    isCbt: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.systemErrorWrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  z-index: 999;

  @include mixins.media() {
    background-color: rgba(255, 255, 255, 0.9);

    &.-page {
      background-color: #fff;
    }
  }
}

.systemError {
  padding-left: 36px;
  padding-right: 36px;
  text-align: center;

  @include mixins.media() {
    width: 712px;
    padding: 40px 90px;
    background-color: #fff;
    position: relative;
  }

  span {
    display: inline-block;
  }

  &.-modal {
    @include mixins.media() {
      border: 1px solid var.$color-main;
      border-radius: 15px;
    }
  }
}

.lead {
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: var.$color-main;

  &::before {
    content: '';
    display: block;
    width: 100px;
    height: 100px;
    margin: 0 auto 10px;
    background: url('~@/assets/images/icon/caution.svg') no-repeat;
    background-size: 100% 100%;

    @include mixins.media() {
      margin-bottom: 20px;
    }
  }

  > strong {
    font-weight: inherit;
  }

  & + p {
    margin-top: 10px;

    @include mixins.media() {
      margin-top: 20px;
    }
  }
}

.close {
  position: absolute;
  top: 17px;
  right: 17px;

  @include mixins.media() {
    top: -35px;
    right: 0;
  }

  > img {
    width: 20px;
    height: 20px;
  }
}

.cbtMargin {
  margin-top: 10px;
}
</style>
